import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57777144")

_pushScopeId("data-v-57777144")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Cambio password")
const _hoisted_2 = { class: "page_content" }
const _hoisted_3 = { class: "data_container" }
const _hoisted_4 = { class: "form_field_container ion-padding-horizontal" }
const _hoisted_5 = { class: "password_input" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Password corrente", -1)
const _hoisted_7 = { class: "psw_container" }
const _hoisted_8 = { class: "password_input" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Nuova password", -1)
const _hoisted_10 = { class: "psw_container" }
const _hoisted_11 = { class: "password_input" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Ripeti nuova password", -1)
const _hoisted_13 = { class: "psw_container" }
const _hoisted_14 = {
  key: 0,
  class: "change_password_container"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "change_password" }, "Cambio password in corso...", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBack()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.arrowBackOutline,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("form", {
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.changePassword()), ["prevent"])),
                class: "form_container"
              }, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_ion_input, {
                        type: _ctx.showCurrentPassword ? 'text' : 'password',
                        modelValue: _ctx.currentPassword,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPassword = $event)),
                        placeholder: "Password attuale"
                      }, null, 8, ["type", "modelValue"]),
                      _createVNode("span", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleShowCurrentPassword && _ctx.toggleShowCurrentPassword(...args)))
                      }, [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.showCurrentPassword ? _ctx.eyeOffOutline : _ctx.eyeOutline,
                          class: "toggle"
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_ion_input, {
                        type: _ctx.showNewPassword ? 'text' : 'password',
                        modelValue: _ctx.newPassword,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newPassword = $event)),
                        placeholder: "Nuova password"
                      }, null, 8, ["type", "modelValue"]),
                      _createVNode("span", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleShowNewPassword && _ctx.toggleShowNewPassword(...args)))
                      }, [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.showNewPassword ? _ctx.eyeOffOutline : _ctx.eyeOutline,
                          class: "toggle"
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_ion_input, {
                        type: _ctx.showConfirmNewPassword ? 'text' : 'password',
                        modelValue: _ctx.confirmNewPassword,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmNewPassword = $event)),
                        placeholder: "Ripeti nuova password"
                      }, null, 8, ["type", "modelValue"]),
                      _createVNode("span", {
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleShowConfirmNewPassword && _ctx.toggleShowConfirmNewPassword(...args)))
                      }, [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.showConfirmNewPassword ? _ctx.eyeOffOutline : _ctx.eyeOutline,
                          class: "toggle"
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ]),
                  (_ctx.loadingChangePassword)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    size: "default",
                    type: "submit",
                    class: "btn_save_password",
                    disabled: _ctx.loadingChangePassword
                  }, " Modifica password ", 8, ["disabled"])
                ])
              ], 32)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})